"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionComparator = void 0;
class ExpressionComparator {
    static standardizeExpression(expression) {
        if (!expression || expression.trim() === '') {
            return '';
        }
        let normalized = expression
            .replace(/(\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\s*\*\s*([A-Za-z_][A-Za-z0-9_]*)/g, '$2*$1')
            .replace(/([A-Za-z_][A-Za-z0-9_]*)\s*\*\s*(\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g, '$1*$2')
            .replace(/([A-Za-z_][A-Za-z0-9_]*)\s*\/\s*(\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g, '$1/$2');
        const terms = [];
        const parts = normalized.split(/(\s*[+-]\s*)/);
        let currentOperator = '+';
        for (const part of parts) {
            const trimmed = part.trim();
            if (trimmed === '+' || trimmed === '-') {
                currentOperator = trimmed;
            }
            else if (trimmed) {
                terms.push({ value: trimmed, operator: currentOperator });
                currentOperator = '+';
            }
        }
        const isNumber = (term) => /^\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/.test(term);
        const positiveNumbers = terms
            .filter((t) => t.operator === '+' && isNumber(t.value))
            .sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
        const negativeNumbers = terms
            .filter((t) => t.operator === '-' && isNumber(t.value))
            .sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
        const positiveVariables = terms
            .filter((t) => t.operator === '+' && !isNumber(t.value))
            .sort((a, b) => a.value.localeCompare(b.value));
        const negativeVariables = terms
            .filter((t) => t.operator === '-' && !isNumber(t.value))
            .sort((a, b) => a.value.localeCompare(b.value));
        const sortedTerms = [...positiveNumbers, ...negativeNumbers, ...positiveVariables, ...negativeVariables];
        let result = '';
        for (let i = 0; i < sortedTerms.length; i++) {
            const term = sortedTerms[i];
            if (i === 0) {
                result += term.operator === '-' ? `-${term.value}` : term.value;
            }
            else {
                result += ` ${term.operator} ${term.value}`;
            }
        }
        return result;
    }
    static compareExpressions(exp1, exp2) {
        return this.standardizeExpression(exp1) === this.standardizeExpression(exp2);
    }
}
exports.ExpressionComparator = ExpressionComparator;
//# sourceMappingURL=ExpressionComparator.js.map